import { Component, h, Prop } from '@stencil/core';
/**
 * @slot title - The title to be displayed.
 * @slot content-line-1 - A slot to include the first line of the description.
 * @slot content-line-2 - A slot to include the second line of the description.
 */
export class IllustrationTextSimpleComponent {
  constructor() {
    /**
     * The illustration path for the component
     */
    this.illustrationPath = '';
    /**
     * The size of the illustration
     */
    this.size = 'lg';
    /**
     * The position of the illustration to be displayed
     */
    this.illustrationPosition = 'top';
  }
  render() {
    return (h("div", { class: { wrapper: true, 'align-image-right': this.illustrationPosition === 'right' } },
      h("div", { class: { wrapper__illustration: this.illustrationPosition === 'right' } },
        h("agl-ds-illustration", { imagePath: this.illustrationPath, size: this.size, "bottom-margin": "none" })),
      h("div", { class: { wrapper__text: true, 'align-text-left': this.illustrationPosition === 'right' } },
        h("div", null,
          h("slot", { name: "title" })),
        h("agl-ds-p", null,
          h("slot", { name: "content-line-1" })),
        h("agl-ds-p", null,
          h("slot", { name: "content-line-2" })))));
  }
  static get is() { return "agl-ds-illustration-text-simple"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["illustration-text-simple.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["illustration-text-simple.component.css"]
  }; }
  static get properties() { return {
    "illustrationPath": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The illustration path for the component"
      },
      "attribute": "illustration-path",
      "reflect": false,
      "defaultValue": "''"
    },
    "size": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "IllustrationSize",
        "resolved": "\"lg\" | \"md\" | \"sm\" | \"xl\" | \"xs\"",
        "references": {
          "IllustrationSize": {
            "location": "import",
            "path": "../../../core/illustration/illustration.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The size of the illustration"
      },
      "attribute": "size",
      "reflect": false,
      "defaultValue": "'lg'"
    },
    "illustrationPosition": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "IllustrationPosition",
        "resolved": "\"right\" | \"top\"",
        "references": {
          "IllustrationPosition": {
            "location": "import",
            "path": "./illustration-text-simple.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The position of the illustration to be displayed"
      },
      "attribute": "illustration-position",
      "reflect": false,
      "defaultValue": "'top'"
    }
  }; }
}
